// extracted by mini-css-extract-plugin
export default {"clickable":"Users_clickable__NFEhz","loaderContainer":"Users_loaderContainer__+j+rU","icon":"Users_icon__m0jwJ"};